import { faDollarCircle } from '@fortawesome/pro-solid-svg-icons/faDollarCircle'
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar'

import Icon from '@space-lib/components/icon'
import { COMMUNITY_TYPE } from '@space-shell/modules/communities/accessAndPrivacy/constants'
type CommunityBadgeProps = {
  type: number
}

const CommunityBadge = ({ type }: CommunityBadgeProps) => {
  return (
    <div className='_h-3 _w-3 _justify-self-end _d-flex _align-items-center _justify-content-center _m-2'>
      {type === COMMUNITY_TYPE.EXCLUSIVE && (
        <Icon data-test='exclusive-community-icon' color='var(--yellow)' icon={faStar} />
      )}
      {type === COMMUNITY_TYPE.PAID && (
        <Icon data-test='paid-community-icon' color='var(--green-darker)' icon={faDollarCircle} />
      )}
    </div>
  )
}

export default CommunityBadge
